// extracted by mini-css-extract-plugin
export default {"planConnector":"QuotaInsurancePlanStep_planConnector__dpsxH","planConnectorIcon":"QuotaInsurancePlanStep_planConnectorIcon__88RQF"};